<template>
  <div>
    <vs-popup
      fullscreen
      title="Escolha a posição do banner de campanha"
      :active.sync="choosePositionPopup"
    >
      <choose-position-popup />
    </vs-popup>

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ this.campaignBanner.id === null ? "ADICIONAR NOVA" : "ATUALIZAR" }} CAMPANHA</h4>
        <feather-icon
          icon="XIcon"
          @click.stop="isSidebarActiveLocal = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <VuePerfectScrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >

        <div class="p-6">
          <!-- Title -->
          <vs-input
            label="Título"
            v-model="campaignBanner.title"
            class="w-full"
            name="title"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('title')"
          >
            {{ errors.first('title') }}
          </span>

          <!-- Description -->
          <vs-input
            label="Descrição"
            v-model="campaignBanner.description"
            class="mt-5 w-full"
            name="description"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('description')"
          >
            {{ errors.first('description') }}
          </span>

          <!-- CTA Label -->
          <!-- <vs-input
            label="Call-to-action Label"
            v-model="campaignBanner.cta_label"
            class="mt-5 w-full"
            name="cta_label"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('cta_label')"
          >
            {{ errors.first('cta_label') }}
          </span> -->

          <!-- Destination URL -->
          <vs-input
            label="Link de Destino da Campanha"
            v-model="campaignBanner.destination_url"
            class="mt-5 w-full"
            name="destination_url"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('destination_url')"
          >
            {{ errors.first('destination_url') }}
          </span>

          <!-- Destination URL -->
          <div class="mt-4 w-full">
            <label for="" class="vs-input--label">Posição da Campanha</label>

            <div class="vs-con-input mt-1 w-full">
              <vs-button
                size="medium"
                @click="choosePositionPopup = true"
              >
                {{ !chosenBanner.position ? 'Escolher' : 'Trocar' }} Posição
              </vs-button>
            </div>
          </div>

          <div v-if="chosenBanner.position" class="mt-2 w-full">
            <vs-chip>
              Posição do Banner: {{ chosenBanner.position }}
            </vs-chip>
          </div>

          <div style="clear: both;" />

          <!-- Image -->
          <vs-input
            type="file"
            label="Faça o Upload da Imagem"
            @change="uploadImage"
            class="mt-5 mb-5 w-full"
            accept="image/jpeg, image/png, image/gif"
            :disabled="!chosenBanner.position"
          />

          <p v-if="errorMessage !== ''" class="text-danger">
            {{ errorMessage }}
          </p>

          <div v-if="campaignBanner.image_url">
            <img :src="campaignBanner.image_url" style="max-height: 80px; max-width: 100%;" />
          </div>

          <vs-input
            v-model="campaignBanner.image_url"
            class="mt-1 w-full"
            name="imagem"
            v-validate="'required'"
            hidden
            readonly
          />

          <!-- Activated -->
          <div class="mt-5 custom-control custom-checkbox">
            <vs-checkbox
              v-model="campaignBanner.activated"
              class="custom-control-label"
              name="activated"
              v-if="this.campaignBanner.id"
            >
              Ativo
            </vs-checkbox>
          </div>
        </div>
      </VuePerfectScrollbar>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || !campaignBanner.image_url">
          Salvar
        </vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
          Cancelar
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import ChoosePositionPopup from './ChoosePositionPopup'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import fileHttp from '@/http/requests/file'

export default {
  name: 'campaign-banner-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    campaignBanner: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          title: null,
          description: null,
          cta_label: null,
          image_url: null,
          destination_url: null,
          activated: true
        }
      }
    }
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      campaignBannerData: {},
      initialCampaignBanner: this.campaignBanner,
      choosePositionPopup: false,
      errorMessage: ''
    }
  },
  watch: {
    'chosenBanner.position': function() {
      if (!this.chosenBanner.sentManually) {
        if (!this.campaignBanner.id) {
          this.removePreviousImage()
            .then(() => {
              this.campaignBanner.image_url = null
              this.choosePositionPopup = false
            }).catch(err => {
              console.error(err)
            })
        } else {
          this.campaignBanner.image_url = null
          this.choosePositionPopup = false
        }
      }
    },
    'campaignBanner.id': function(val) {
      if (val === null) {
        this.$store.dispatch("campaignBanners/resetChosenBanner")
      } else {
        this.$store.dispatch("campaignBanners/setChosenBanner", {
          event: {
            userId: this.$store.state.AppActiveUser.id,
            sentManually: true,
            position: this.campaignBanner.position,
            direction: this.campaignBanner.direction,
            hasBanner: false,
          },
          userId: this.$store.state.AppActiveUser.id
        })
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    },
    chosenBanner() {
      return this.$store.state.campaignBanners.chosenBanner
    }
  },
  methods: {
    initValues() {
      this.campaignBannerData = this.$_.cloneDeep(this.campaignBanner);
    },
    uploadImage(e) {
      const files = e.target.files

      if(files.length) {
        const file = files[0]
        fileHttp.upload(file, this.chosenBanner.direction).then(res => {
          const uploadedImage = res.data;
          
          if (!uploadedImage.success) {
            this.errorMessage = uploadedImage.message
            return false
          }

          this.removePreviousImage()
            .then(() => {
              this.errorMessage = ''
              this.campaignBanner.image_url = uploadedImage.fileUrl
            }).catch(err => {
              console.error(err)
            })
        }).catch(err => {
          console.error(err)
        })
      }
    },
    removePreviousImage() {
      return new Promise((resolve, reject) => {
        const fileUrl = this.campaignBanner.image_url;

        if (fileUrl) {
          const urlArray = fileUrl.split("/");
          const filename = urlArray[urlArray.length - 1]

          fileHttp
          .delete(filename)
          .then(() => { return resolve({}) })
          .catch(err => { return reject(err) })
        }

        return resolve({})
      })
    },
    submitData() {
      const that = this

      this.$validator.validateAll().then(result => {
        if (result) {
          delete this.campaignBanner.clicks_qty
          
          const destinationUrl = this.campaignBanner.destination_url

          if (!destinationUrl.startsWith('https://') && !destinationUrl.startsWith('http://')) {
            this.campaignBanner.destination_url = `https://${destinationUrl}`
          }

          if (this.campaignBanner.id !== null && this.campaignBanner.id >= 0) {
            this.$store.dispatch("campaignBanners/update", {
              ...this.campaignBanner, 
              position: this.chosenBanner.position,
              direction: this.chosenBanner.direction,
            }).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
              this.$emit('refreshList')

              this.campaignBanner = {
                id: null,
                title: null,
                description: null,
                cta_label: null,
                image_url: null,
                destination_url: null,
                activated: true
              }
            }).catch(err => {
              console.error(err)
            })
          } else {
            delete this.campaignBanner.id
            delete this.campaignBanner.activated
            this.$store.dispatch("campaignBanners/add", {
              ...this.campaignBanner, 
              position: this.chosenBanner.position,
              direction: this.chosenBanner.direction,
            }).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
              this.$emit('refreshList')

              this.campaignBanner = {
                id: null,
                title: null,
                description: null,
                cta_label: null,
                image_url: null,
                destination_url: null,
                activated: true
              }
            }).catch(err => {
              console.error(err)
            })
          }
        }
      })
    }
  },
  components: {
    VuePerfectScrollbar,
    ChoosePositionPopup
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
